import { defineComponent, computed, toRefs, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import { capitalize } from "lodash";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "SelectRequestType",
  components: {
    MaterialInput,
    vSelectField
  },
  props: {
    selectedRequestType: {
      type: [String, Array],
      required: true,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ""
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const {
      selectedRequestType,
      multiple
    } = toRefs(props);
    const select = ref();
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const requestTypeOptions = computed(() => [{
      id: "all",
      text: capitalize(tc("global.words.all", 1))
    }, {
      id: "existing",
      text: t("application-form.existing")
    }, {
      id: "requested",
      text: t("application-form.requested")
    }]);
    const localSelectedRequestType = computed({
      get() {
        var _selectedRequestType$;
        return (_selectedRequestType$ = selectedRequestType.value) != null ? _selectedRequestType$ : multiple.value ? [] : "";
      },
      set(newValue) {
        emit("update:selectedRequestType", newValue);
      }
    });
    const handleChange = (selectedValue, type) => {
      var _select$value;
      if (selectedValue.id === "all") (_select$value = select.value) == null ? void 0 : _select$value.close();
      localSelectedRequestType.value = handleSelectMultipleChange(selectedValue, type, localSelectedRequestType.value, multiple.value);
    };
    const options = computed(() => ({
      placeholder: t("global.actions.chooseOption"),
      closeOnSelect: !multiple.value
    }));
    return {
      select,
      requestTypeOptions,
      localSelectedRequestType,
      handleChange,
      options
    };
  }
});